import React from "react";
import ReactDOM from "react-dom";

interface AlertaDebitoModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const OverdueAlertModal: React.FC<AlertaDebitoModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className=" dark:text-black fixed inset-0 z-[9999] flex items-center justify-center"
      style={{ backgroundColor: "#0d0d0d70" }}
      aria-modal="true"
      role="alertdialog"
      aria-labelledby="alerta-debito-titulo"
    >
      <div className="bg-white rounded-lg shadow-xl w-full max-w-sm p-6 relative">
        {/* Linha de destaque no topo */}
        <div
          className="absolute top-0 left-0 w-full h-1"
          style={{ backgroundColor: "rgb(228,65,49)" }}
        />

        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-2xl"
          aria-label="Fechar"
        >
          &times;
        </button>

        <h2
          id="alerta-debito-titulo"
          className="dark:text-black text-2xl font-bold text-gray-800 mb-4 text-center"
        >
          ⚠️ Atenção!
        </h2>
        <p className=" dark:text-black text-gray-600 mb-6 text-justify m-4 mt-7">
          O locatário possui pendências financeiras. Oriente-o a procurar o setor financeiro para regularização.
        </p>
        <div className="flex justify-center">
          <button
            onClick={onClose}
            className="px-6 py-2 rounded-full bg-[rgb(228,65,49)] hover:bg-red-600 text-white font-semibold transition"
          >
            Entendi
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};
